import { MediaPreview } from '@anytag/shared-atoms';
import { MessageType } from './types';

export interface FileProps {
  file?: MessageType['file'];
}
export const File = ({ file }: FileProps) =>
  //  Only support image type message for now
  file?.type === 'image' && file.url ? (
    <MediaPreview src={file.url} css={{ width: '80px', height: '80px', borderRadius: '8px' }} />
  ) : null;
